import Vue from "vue";
import App from "./App.vue";
import picker from "vue-scroll-select";
import "vue-scroll-select/dist/vue-scroll-select.css";

Vue.use(picker);

Vue.config.productionTip = false;

new Vue({
  render: h => h(App)
}).$mount("#app");
